/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Windows_S3Inputs */

const en_fc_dl_windows_s3 = /** @type {(inputs: Fc_Dl_Windows_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefer no install? Unzip the Portable build anywhere and run the FilmCraft program inside the folder.`)
};

/**
* | output |
* | --- |
* | "Prefer no install? Unzip the Portable build anywhere and run the FilmCraft program inside the folder." |
*
* @param {Fc_Dl_Windows_S3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_windows_s3 = /** @type {((inputs?: Fc_Dl_Windows_S3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Windows_S3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_windows_s3(inputs)
});
export { fc_dl_windows_s3 as "fc.dl.windows.s3" }